import React from "react";
import { Button } from "components/ui";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { DEPENDENCY_BRANCH_UPDATE_PERMISSION } from "components/dashboard/TrainSAM/Dependency/permissions";
import { CAPSULE_UPDATE_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import { ISSUE_CONVERSATION_UPDATE_PERMISSION } from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";
import { baseResources, baseResourceActions } from "routes/enum";
import "./ImageCropButtons.scss";

const { AGENTS_INBOX_CONVERSATION_BREAKER } = baseResources;
const { UPDATE } = baseResourceActions;

const ImageCropButtons = ({
    loading,
    closeModal,
    handleContinue,
    disable,
    isEdit,
}) => {
    return (
        <div className='image__crop__buttons'>
            <ComponentAccessControl
                baseResources={[
                    ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
                    ...CAPSULE_UPDATE_PERMISSION,
                    `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
                    ...ISSUE_CONVERSATION_UPDATE_PERMISSION,
                ]}>
                <Button
                    text={`${isEdit ? "Replace" : "Continue"}`}
                    type='submit'
                    classType='primary'
                    otherClass='w-100'
                    loading={loading}
                    onClick={handleContinue}
                    disabled={disable}
                />
            </ComponentAccessControl>
            <Button
                text='Cancel'
                type='submit'
                classType='plain'
                otherClass='w-100 fw-bold'
                onClick={closeModal}
            />
        </div>
    );
};

export default ImageCropButtons;
